import React, {Component} from 'react'
import {Nav, NavItem, MenuItem, NavDropdown, Image, Glyphicon, Badge} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {LinkContainer} from 'react-router-bootstrap'
import showToastr from '../../../utils/showToastr'
import {MdNotifications, FaTelegram} from '../ReactIcons/icons'

import './Layout/NavigationLinks.css'

const avatar = `${window.location.protocol}//${window.location.host}/default_avatar.png`

class NavigationLinks extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({user: nextProps.user})
  }

  render () {
    const {user} = this.state
    const logout = () => {
      Actions.logout()
      showToastr('info', 'خروج', 'شما از سیستم خارج شدید')
    }
    const {isAuthenticated} = this.props.auth
    return (
      <Nav pullLeft>

        <NavDropdown eventKey={2} title={<Glyphicon glyph="th" />} id="launcherDropdown" >
          {isAuthenticated && <LinkContainer to="/new-horse">
            <MenuItem eventKey={2.1}>ثبت اسب جدید</MenuItem>
          </LinkContainer>}
          {!isAuthenticated &&
            <MenuItem eventKey={2.1} onClick={() => Actions.toggleLoginBox(true)}>ثبت اسب جدید</MenuItem>
          }
          <LinkContainer to="/new-features">
            <MenuItem eventKey={2.2}>ویژگی‌های جدید</MenuItem>
          </LinkContainer>
          <LinkContainer to="/ads">
            <MenuItem eventKey={2.3}>آگهی‌ها</MenuItem>
          </LinkContainer>
          <LinkContainer to="/store">
            <MenuItem eventKey={2.4}>فروشگاه</MenuItem>
          </LinkContainer>
          <LinkContainer to="/donate">
            <MenuItem eventKey={2.5}>حمایت</MenuItem>
          </LinkContainer>
          <MenuItem divider />
          <LinkContainer to="/page/terms-of-service">
            <MenuItem eventKey={2.6}>قوانین سرویس</MenuItem>
          </LinkContainer>
          <LinkContainer to="/page/about">
            <MenuItem eventKey={2.7}>درباره ما</MenuItem>
          </LinkContainer>
        </NavDropdown>

        {!isAuthenticated &&
          <LinkContainer to="/login">
            <NavItem id="login" eventKey={0}>ورود</NavItem>
          </LinkContainer>}
        <LinkContainer id="telegramLink" to="https://t.me/joinchat/AAAAAEFiX3M1rkQ5EUMAyA" target="_blank">
          <MenuItem>
            <FaTelegram height="1.6em" width="1.6em" />
          </MenuItem>
        </LinkContainer>

        {isAuthenticated && user.currentUser &&
          <LinkContainer to="/user/notification">
            <NavItem eventKey={3}><MdNotifications className="NotifiIcon" />{user.currentUser.notification > 0 && <Badge className="badge-notification">{user.currentUser.notification}</Badge>}</NavItem>
          </LinkContainer>}

        {isAuthenticated && user.currentUser &&
          <NavDropdown eventKey={1} title={<Image className="savatar" src={user.currentUser.avatar.thumb ? user.currentUser.avatar.thumb : avatar} circle />} id="avatarDropdown">
            <LinkContainer to="/user/dashboard">
              <MenuItem eventKey={1.1}>داشبورد</MenuItem>
            </LinkContainer>
            <LinkContainer to="/user/profile">
              <MenuItem eventKey={1.2}>پروفایل</MenuItem>
            </LinkContainer>
            <LinkContainer to="/user/profile-edit">
              <MenuItem eventKey={1.2}>ویرایش پروفایل</MenuItem>
            </LinkContainer>
            <LinkContainer to="/user/change-password">
              <MenuItem eventKey={1.3}>تغییر رمز عبور</MenuItem>
            </LinkContainer>
            <MenuItem divider />
            <MenuItem eventKey={1.4} onClick={logout}>خروج</MenuItem>
          </NavDropdown>}
      </Nav>
    )
  }
}

NavigationLinks.contextTypes = {
  router: React.PropTypes.object
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    user: state.user
  }
}

export default connect(mapStateToProps)(NavigationLinks)



// WEBPACK FOOTER //
// ./src/components/Common/NavigationLinks/NavigationLinks.js